import React, { useEffect, useState } from "react";
import { useContext } from "react";
import { CanvasContext } from "../../../contexts/CanvasContext";
const DropDownComponent = ({ dropdown }) => {
  const { hoveredDivision, files } = useContext(CanvasContext);

  const isHovered = dropdown.id === hoveredDivision;
  const [isDivHovered, setIsDivHovered] = useState(false);
  const [isDivFocused, setIsDivFocused] = useState(false);
  const [isDivActive, setIsDivActive] = useState(false);
  const [backgroundImageUrl, setBackgroundImageUrl] = useState(null);

  const constructGradientString = () => {
    const {
      backgroundGradientImage,
      gradientDirection,
      gradientShape,
      gradientPosition,
      startColor,
      endColor,
      gradientAngle,
      patternLength,
    } = dropdown;

    switch (backgroundGradientImage) {
      case "linear-gradient":
        return `linear-gradient(${gradientDirection || "to right"}, ${
          startColor || "#ff7e5f"
        }, ${endColor || "#feb47b"})`;

      case "radial-gradient":
        return `radial-gradient(${gradientShape || "circle"} at ${
          gradientPosition || "center"
        }, ${startColor || "#ff7e5f"}, ${endColor || "#feb47b"})`;

      case "repeating-linear-gradient":
        return `repeating-linear-gradient(${gradientAngle || "45"}deg, ${
          startColor || "#606dbc"
        }, ${endColor || "#465298"} ${patternLength || "10"}px)`;

      case "repeating-radial-gradient":
        return `repeating-radial-gradient(${gradientShape || "circle"} at ${
          gradientPosition || "center"
        }, ${startColor || "#ff7e5f"}, ${endColor || "#feb47b"} ${
          patternLength || "10"
        }%)`;

      default:
        return "none";
    }
  };
  const constructHoverGradientString = () => {
    const {
      hoveredbackgroundGradientImage,
      hoveredgradientDirection,
      hoveredgradientShape,
      hoveredgradientPosition,
      hoveredstartColor,
      hoveredendColor,
      hoveredgradientAngle,
      hoveredpatternLength,
    } = dropdown;

    switch (hoveredbackgroundGradientImage) {
      case "linear-gradient":
        return `linear-gradient(${hoveredgradientDirection || "to right"}, ${
          hoveredstartColor || "#ff7e5f"
        }, ${hoveredendColor || "#feb47b"})`;

      case "radial-gradient":
        return `radial-gradient(${hoveredgradientShape || "circle"} at ${
          hoveredgradientPosition || "center"
        }, ${hoveredstartColor || "#ff7e5f"}, ${hoveredendColor || "#feb47b"})`;

      case "repeating-linear-gradient":
        return `repeating-linear-gradient(${hoveredgradientAngle || "45"}deg, ${
          hoveredstartColor || "#606dbc"
        }, ${hoveredendColor || "#465298"} ${hoveredpatternLength || "10"}px)`;

      case "repeating-radial-gradient":
        return `repeating-radial-gradient(${
          hoveredgradientShape || "circle"
        } at ${hoveredgradientPosition || "center"}, ${
          hoveredstartColor || "#ff7e5f"
        }, ${hoveredendColor || "#feb47b"} ${hoveredpatternLength || "10"}%)`;

      default:
        return "none";
    }
  };
  const constructFocusedGradientString = () => {
    const {
      focusedbackgroundGradientImage,
      focusedgradientDirection,
      focusedgradientShape,
      focusedgradientPosition,
      focusedstartColor,
      focusedendColor,
      focusedgradientAngle,
      focusedpatternLength,
    } = dropdown;

    switch (focusedbackgroundGradientImage) {
      case "linear-gradient":
        return `linear-gradient(${focusedgradientDirection || "to right"}, ${
          focusedstartColor || "#ff7e5f"
        }, ${focusedendColor || "#feb47b"})`;

      case "radial-gradient":
        return `radial-gradient(${focusedgradientShape || "circle"} at ${
          focusedgradientPosition || "center"
        }, ${focusedstartColor || "#ff7e5f"}, ${focusedendColor || "#feb47b"})`;

      case "repeating-linear-gradient":
        return `repeating-linear-gradient(${focusedgradientAngle || "45"}deg, ${
          focusedstartColor || "#606dbc"
        }, ${focusedendColor || "#465298"} ${focusedpatternLength || "10"}px)`;

      case "repeating-radial-gradient":
        return `repeating-radial-gradient(${
          focusedgradientShape || "circle"
        } at ${focusedgradientPosition || "center"}, ${
          focusedstartColor || "#ff7e5f"
        }, ${focusedendColor || "#feb47b"} ${focusedpatternLength || "10"}%)`;

      default:
        return "none";
    }
  };
  const constructActivatedGradientString = () => {
    const {
      activatedbackgroundGradientImage,
      activatedgradientDirection,
      activatedgradientShape,
      activatedgradientPosition,
      activatedstartColor,
      activatedendColor,
      activatedgradientAngle,
      activatedpatternLength,
    } = dropdown;

    switch (activatedbackgroundGradientImage) {
      case "linear-gradient":
        return `linear-gradient(${activatedgradientDirection || "to right"}, ${
          activatedstartColor || "#ff7e5f"
        }, ${activatedendColor || "#feb47b"})`;

      case "radial-gradient":
        return `radial-gradient(${activatedgradientShape || "circle"} at ${
          activatedgradientPosition || "center"
        }, ${activatedstartColor || "#ff7e5f"}, ${
          activatedendColor || "#feb47b"
        })`;

      case "repeating-linear-gradient":
        return `repeating-linear-gradient(${
          activatedgradientAngle || "45"
        }deg, ${activatedstartColor || "#606dbc"}, ${
          activatedendColor || "#465298"
        } ${activatedpatternLength || "10"}px)`;

      case "repeating-radial-gradient":
        return `repeating-radial-gradient(${
          activatedgradientShape || "circle"
        } at ${activatedgradientPosition || "center"}, ${
          activatedstartColor || "#ff7e5f"
        }, ${activatedendColor || "#feb47b"} ${
          activatedpatternLength || "10"
        }%)`;

      default:
        return "none";
    }
  };

  useEffect(() => {
    const fetchBackgroundImage = async () => {
      if (
        dropdown.backgroundImage &&
        dropdown.backgroundImage.startsWith("./")
      ) {
        const imageName = dropdown.backgroundImage.replace("./", "");
        const file = files.find((f) => f.name === imageName);
        if (file && file.data) {
          setBackgroundImageUrl(file.data);
        } else {
          console.error("Image not found in files:", imageName);
        }
      } else {
        setBackgroundImageUrl(dropdown.backgroundImage);
      }
    };

    fetchBackgroundImage();
  }, [dropdown.backgroundImage, files]);


  const focusedStyles =
    isDivFocused && dropdown.pseudoClass === "focus"
      ? {
          padding: `${
            dropdown.focusedpaddingTop ||
            dropdown.focusedpadding ||
            dropdown.paddingTop ||
            "0px"
          } ${
            dropdown.focusedpaddingRight ||
            dropdown.focusedpadding ||
            dropdown.paddingRight ||
            "0px"
          } ${
            dropdown.focusedpaddingBottom ||
            dropdown.focusedpadding ||
            dropdown.paddingBottom ||
            "0px"
          } ${
            dropdown.focusedpaddingLeft ||
            dropdown.focusedpadding ||
            dropdown.paddingLeft ||
            "0px"
          }`,
          margin: `${
            dropdown.focusedmarginTop ||
            dropdown.focusedmargin ||
            dropdown.marginTop ||
            "0px"
          } ${
            dropdown.focusedmarginRight ||
            dropdown.focusedmargin ||
            dropdown.marginRight ||
            "5px"
          } ${
            dropdown.focusedmarginBottom ||
            dropdown.focusedmargin ||
            dropdown.marginBottom ||
            "0px"
          } ${
            dropdown.focusedmarginLeft ||
            dropdown.focusedmargin ||
            dropdown.marginLeft ||
            "0px"
          }`,
          border:
            dropdown.focusedborder || dropdown.border || "1px solid black",
          borderRadius:
            dropdown.focusedborderRadius || dropdown.borderRadius || "0",
          opacity: dropdown.focusedOpacity || dropdown.opacity || 1,
          color: dropdown.focusedcolor || dropdown.color || "#000",
          backgroundColor:
            dropdown.focusedbackgroundColor ||
            dropdown.backgroundColor ||
            "white",
          boxShadow: dropdown.focusedboxShadow || dropdown.boxShadow || "none",
          transform: dropdown.focusedtransform || dropdown.transform || "none",
          transition:
            dropdown.focusedtransition || dropdown.transition || "none",

          backgroundImage: (() => {
            if (dropdown.focusedbackgroundImage) {
              if (dropdown.focusedbackgroundImage.startsWith("./")) {
                const imageName = dropdown.focusedbackgroundImage.replace(
                  "./",
                  ""
                );
                const file = files.find((f) => f.name === imageName);
                return file && file.data ? `url(${file.data})` : "none";
              }
              return `url(${dropdown.focusedbackgroundImage})`;
            }
            if (dropdown.backgroundImage) {
              if (dropdown.backgroundImage.startsWith("./")) {
                const imageName = dropdown.backgroundImage.replace("./", "");
                const file = files.find((f) => f.name === imageName);
                return file && file.data ? `url(${file.data})` : "none";
              }
              return `url(${dropdown.backgroundImage})`;
            }
            return (
              constructFocusedGradientString() ||
              constructGradientString() ||
              "none"
            );
          })(),

          backgroundPosition:
            dropdown.focusedbackgroundPosition ||
            dropdown.backgroundPosition ||
            "0% 0%",
          backgroundSize:
            dropdown.focusedbackgroundSize || dropdown.backgroundSize || "auto",
          backgroundRepeat:
            dropdown.focusedbackgroundRepeat ||
            dropdown.backgroundRepeat ||
            "repeat",
          backgroundAttachment:
            dropdown.focusedbackgroundAttachment ||
            dropdown.backgroundAttachment ||
            "scroll",
          fontSize: dropdown.focusedfontSize || dropdown.fontSize || "inherit",
          fontWeight:
            dropdown.focusedfontWeight || dropdown.fontWeight || "normal",
          lineHeight:
            dropdown.focusedlineHeight || dropdown.lineHeight || "normal",
          textDecoration:
            dropdown.focusedtextDecoration || dropdown.textDecoration || "none",
          textShadow:
            dropdown.focusedtextShadow || dropdown.textShadow || "none",
          letterSpacing:
            dropdown.focusedletterSpacing || dropdown.letterSpacing || "normal",
          cursor: dropdown.focusedcursor || dropdown.cursor || "default",
        }
      : {};
  const hoverStyles =
    isDivHovered && dropdown.pseudoClass === "hover"
      ? {
          padding: `${
            dropdown.hoveredpaddingTop ||
            dropdown.hoveredpadding ||
            dropdown.paddingTop ||
            "0px"
          } ${
            dropdown.hoveredpaddingRight ||
            dropdown.hoveredpadding ||
            dropdown.paddingRight ||
            "0px"
          } ${
            dropdown.hoveredpaddingBottom ||
            dropdown.hoveredpadding ||
            dropdown.paddingBottom ||
            "0px"
          } ${
            dropdown.hoveredpaddingLeft ||
            dropdown.hoveredpadding ||
            dropdown.paddingLeft ||
            "0px"
          }`,
          margin: `${
            dropdown.hoveredmarginTop ||
            dropdown.hoveredmargin ||
            dropdown.marginTop ||
            "0px"
          } ${
            dropdown.hoveredmarginRight ||
            dropdown.hoveredmargin ||
            dropdown.marginRight ||
            "5px"
          } ${
            dropdown.hoveredmarginBottom ||
            dropdown.hoveredmargin ||
            dropdown.marginBottom ||
            "0px"
          } ${
            dropdown.hoveredmarginLeft ||
            dropdown.hoveredmargin ||
            dropdown.marginLeft ||
            "0px"
          }`,
          border:
            dropdown.hoveredborder || dropdown.border || "1px solid black",
          borderRadius:
            dropdown.hoveredborderRadius || dropdown.borderRadius || "0",
          opacity: dropdown.hoveredOpacity || dropdown.opacity || 1,
          color: dropdown.hoveredcolor || dropdown.color || "#000",
          backgroundColor:
            dropdown.hoveredbackgroundColor ||
            dropdown.backgroundColor ||
            "white",
          boxShadow: dropdown.hoveredboxShadow || dropdown.boxShadow || "none",
          transform: dropdown.hoveredtransform || dropdown.transform || "none",
          transition:
            dropdown.hoveredtransition || dropdown.transition || "none",
          backgroundImage: (() => {
            if (dropdown.hoveredbackgroundImage) {
              if (dropdown.hoveredbackgroundImage.startsWith("./")) {
                const imageName = dropdown.hoveredbackgroundImage.replace(
                  "./",
                  ""
                );
                const file = files.find((f) => f.name === imageName);
                return file && file.data ? `url(${file.data})` : "none";
              }
              return `url(${dropdown.hoveredbackgroundImage})`;
            }
            if (dropdown.backgroundImage) {
              if (dropdown.backgroundImage.startsWith("./")) {
                const imageName = dropdown.backgroundImage.replace("./", "");
                const file = files.find((f) => f.name === imageName);
                return file && file.data ? `url(${file.data})` : "none";
              }
              return `url(${dropdown.backgroundImage})`;
            }
            return (
              constructHoverGradientString() ||
              constructGradientString() ||
              "none"
            );
          })(),

          backgroundPosition:
            dropdown.hoveredbackgroundPosition ||
            dropdown.backgroundPosition ||
            "0% 0%",
          backgroundSize:
            dropdown.hoveredbackgroundSize || dropdown.backgroundSize || "auto",
          backgroundRepeat:
            dropdown.hoveredbackgroundRepeat ||
            dropdown.backgroundRepeat ||
            "repeat",
          backgroundAttachment:
            dropdown.hoveredbackgroundAttachment ||
            dropdown.backgroundAttachment ||
            "scroll",
          fontSize: dropdown.hoveredfontSize || dropdown.fontSize || "inherit",
          fontWeight:
            dropdown.hoveredfontWeight || dropdown.fontWeight || "normal",
          lineHeight:
            dropdown.hoveredlineHeight || dropdown.lineHeight || "normal",
          textDecoration:
            dropdown.hoveredtextDecoration || dropdown.textDecoration || "none",
          textShadow:
            dropdown.hoveredtextShadow || dropdown.textShadow || "none",
          letterSpacing:
            dropdown.hoveredletterSpacing || dropdown.letterSpacing || "normal",
          cursor: dropdown.hoveredcursor || dropdown.cursor || "default",
        }
      : {};
  const activeStyles =
    isDivActive && dropdown.pseudoClass === "active"
      ? {
          padding: `${
            dropdown.activatedpaddingTop ||
            dropdown.activatedpadding ||
            dropdown.paddingTop ||
            "0px"
          } ${
            dropdown.activatedpaddingRight ||
            dropdown.activatedpadding ||
            dropdown.paddingRight ||
            "0px"
          } ${
            dropdown.activatedpaddingBottom ||
            dropdown.activatedpadding ||
            dropdown.paddingBottom ||
            "0px"
          } ${
            dropdown.activatedpaddingLeft ||
            dropdown.activatedpadding ||
            dropdown.paddingLeft ||
            "0px"
          }`,
          margin: `${
            dropdown.activatedmarginTop ||
            dropdown.activatedmargin ||
            dropdown.marginTop ||
            "0px"
          } ${
            dropdown.activatedmarginRight ||
            dropdown.activatedmargin ||
            dropdown.marginRight ||
            "5px"
          } ${
            dropdown.activatedmarginBottom ||
            dropdown.activatedmargin ||
            dropdown.marginBottom ||
            "0px"
          } ${
            dropdown.activatedmarginLeft ||
            dropdown.activatedmargin ||
            dropdown.marginLeft ||
            "0px"
          }`,
          border:
            dropdown.activatedborder || dropdown.border || "1px solid black",
          borderRadius:
            dropdown.activatedborderRadius || dropdown.borderRadius || "0",
          opacity: dropdown.activatedOpacity || dropdown.opacity || 1,
          color: dropdown.activatedcolor || dropdown.color || "#000",
          backgroundColor:
            dropdown.activatedbackgroundColor ||
            dropdown.backgroundColor ||
            "white",
          boxShadow:
            dropdown.activatedboxShadow || dropdown.boxShadow || "none",
          transform:
            dropdown.activatedtransform || dropdown.transform || "none",
          transition:
            dropdown.activatedtransition || dropdown.transition || "none",

          backgroundImage: (() => {
            if (dropdown.activatedbackgroundImage) {
              if (dropdown.activatedbackgroundImage.startsWith("./")) {
                const imageName = dropdown.activatedbackgroundImage.replace(
                  "./",
                  ""
                );
                const file = files.find((f) => f.name === imageName);
                return file && file.data ? `url(${file.data})` : "none";
              }
              return `url(${dropdown.activatedbackgroundImage})`;
            }
            if (dropdown.backgroundImage) {
              if (dropdown.backgroundImage.startsWith("./")) {
                const imageName = dropdown.backgroundImage.replace("./", "");
                const file = files.find((f) => f.name === imageName);
                return file && file.data ? `url(${file.data})` : "none";
              }
              return `url(${dropdown.backgroundImage})`;
            }
            return (
              constructActivatedGradientString() ||
              constructGradientString() ||
              "none"
            );
          })(),
          backgroundPosition:
            dropdown.activatedbackgroundPosition ||
            dropdown.backgroundPosition ||
            "0% 0%",
          backgroundSize:
            dropdown.activatedbackgroundSize ||
            dropdown.backgroundSize ||
            "auto",
          backgroundRepeat:
            dropdown.activatedbackgroundRepeat ||
            dropdown.backgroundRepeat ||
            "repeat",
          backgroundAttachment:
            dropdown.activatedbackgroundAttachment ||
            dropdown.backgroundAttachment ||
            "scroll",
          fontSize:
            dropdown.activatedfontSize || dropdown.fontSize || "inherit",
          fontWeight:
            dropdown.activatedfontWeight || dropdown.fontWeight || "normal",
          lineHeight:
            dropdown.activatedlineHeight || dropdown.lineHeight || "normal",
          textDecoration:
            dropdown.activatedtextDecoration ||
            dropdown.textDecoration ||
            "none",
          textShadow:
            dropdown.activatedtextShadow || dropdown.textShadow || "none",
          letterSpacing:
            dropdown.activatedletterSpacing ||
            dropdown.letterSpacing ||
            "normal",
          cursor: dropdown.activatedcursor || dropdown.cursor || "default",
        }
      : {};

  const dropdownStyle = {
    width: dropdown.width || "fit-content",
    height: dropdown.height || "auto",

    margin: dropdown.margin || "0px",
    marginTop: dropdown.marginTop || dropdown.margin || "0",
    marginRight: dropdown.marginRight || dropdown.margin || "5px",
    marginBottom: dropdown.marginBottom || dropdown.margin || "0",
    marginLeft: dropdown.marginLeft || dropdown.margin || "0px",
    padding: dropdown.padding || "0px",
    paddingTop: dropdown.paddingTop || dropdown.padding || "3px",
    paddingRight: dropdown.paddingRight || dropdown.padding || "3px",
    paddingBottom: dropdown.paddingBottom || dropdown.padding || "3px",
    paddingLeft: dropdown.paddingLeft || dropdown.padding || "3px",

    borderTop: isHovered
      ? "1px dashed #555"
      : dropdown.borderTop || dropdown.border || "1px solid #000000",
    borderRight: isHovered
      ? "1px dashed #555"
      : dropdown.borderRight || dropdown.border || "1px solid #000000",
    borderBottom: isHovered
      ? "1px dashed #555"
      : dropdown.borderBottom || dropdown.border || "1px solid #000000",
    borderLeft: isHovered
      ? "1px dashed #555"
      : dropdown.borderLeft || dropdown.border || "1px solid #000000",

    borderSapcing: dropdown.borderSpacing || "0px",
    borderCollapse: dropdown.borderCollapse || "0px",
    borderRadius: dropdown.borderRadius || "0",
    outline: dropdown.outline || "none",

    position: dropdown.position || "static",
    top: dropdown.top || "auto",
    right: dropdown.right || "auto",
    bottom: dropdown.bottom || "auto",
    left: dropdown.left || "auto",
    zIndex: dropdown.zIndex || "auto",

    color: dropdown.color || "#000000",
    backgroundColor: dropdown.backgroundColor || "#ffffff",
    backgroundImage: backgroundImageUrl
      ? `url(${backgroundImageUrl})`
      : constructGradientString(),
    backgroundPosition:
      dropdown.focusedbackgroundPosition ||
      dropdown.backgroundPosition ||
      "0% 0%",
    backgroundSize:
      dropdown.focusedbackgroundSize || dropdown.backgroundSize || "auto",
    backgroundRepeat:
      dropdown.focusedbackgroundRepeat ||
      dropdown.backgroundRepeat ||
      "repeat",
    backgroundAttachment:
      dropdown.focusedbackgroundAttachment ||
      dropdown.backgroundAttachment ||
      "scroll",

    fontSize: dropdown.fontSize || "inherit",
    fontFamily: dropdown.fontFamily || "inherit",
    fontWeight: dropdown.fontWeight || "normal",
    fontStyle: dropdown.fontStyle || "normal",
    fontVariant: dropdown.fontVariant || "normal",
    lineHeight: dropdown.lineHeight || "normal",
    textAlign: dropdown.textAlign || "left",
    textDecoration: dropdown.textDecoration || "none",
    textTransform: dropdown.textTransform || "none",
    textShadow: dropdown.textShadow || "none",
    verticalAlign: dropdown.verticalAlign || "baseline",
    letterSpacing: dropdown.letterSpacing || "normal",
    wordSpacing: dropdown.wordSpacing || "normal",
    textIndent: dropdown.textIndent || "0",
    whiteSpace: dropdown.whiteSpace || "normal",
    textOverflow: dropdown.textOverflow || "clip",
    direction: dropdown.direction || "ltr",
    unicodeBidi: dropdown.unicodeBidi || "normal",
    writingMode: dropdown.writingMode || "horizontal-tb",

    opacity: dropdown.opacity || "1",
    display: dropdown.display || "inline",
    cursor: dropdown.cursor || "auto",

    transform: dropdown.transform || "none",
    transition: dropdown.transition || "none",

    scale: isHovered ? "1.01" : "1",
    ...hoverStyles,
    ...focusedStyles,
    ...activeStyles,
  };

  const optionStyle = {
    margin: dropdown.optionMargin || "0",
    padding: dropdown.optionPadding || "0",
  };

  const optionsArray = dropdown.options
    ? dropdown.options.split(",").map((option) => option.trim())
    : ["DropDownOtions"];

  return (
    <select
      style={dropdownStyle}
      multiple={dropdown.multiple === true}
      disabled={dropdown.disabled === true}
      onMouseEnter={() => setIsDivHovered(true)}
      onMouseLeave={() => setIsDivHovered(false)}
      onFocus={() => setIsDivFocused(true)}
      onBlur={() => setIsDivFocused(false)}
      onMouseDown={() => setIsDivActive(true)}
      onMouseUp={() => setIsDivActive(false)}
    >
      {optionsArray.map((option, index) => (
        <option key={index} style={optionStyle} value={option}>
          {option}
        </option>
      ))}
    </select>
  );
};

export default DropDownComponent;
